package org.zest.insan_360_website.pages.user.students_layout

import androidx.compose.runtime.Composable
import androidx.compose.runtime.rememberCoroutineScope
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.icons.fa.*
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import kotlinx.browser.window
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.dom.Input
import org.zest.insan_360_website.components.layouts.*
import org.zest.insan_360_website.components.widgets.*
import org.zest.insan_360_website.data.LanguageSettings
import org.zest.insan_360_website.data.localized
import org.zest.insan_360_website.data.page_states.AuthState
import org.zest.insan_360_website.data.page_states.UserPreferences
import org.zest.insan_360_website.data.page_states.dashboard.StudentsDashboardState.assignCredit
import org.zest.insan_360_website.data.page_states.dashboard.StudentsDashboardState.getFilteredMergedList
import org.zest.insan_360_website.data.page_states.dashboard.StudentsDashboardState.inviteEmail
import org.zest.insan_360_website.data.page_states.dashboard.StudentsDashboardState.inviteState
import org.zest.insan_360_website.data.page_states.dashboard.StudentsDashboardState.isConfirmingInvite
import org.zest.insan_360_website.data.page_states.dashboard.StudentsDashboardState.isInviting
import org.zest.insan_360_website.data.page_states.dashboard.StudentsDashboardState.needUpdate
import org.zest.insan_360_website.data.page_states.dashboard.StudentsDashboardState.searchQuery
import org.zest.insan_360_website.data.page_states.dashboard.StudentsDashboardState.sendInvite
import org.zest.insan_360_website.model.InviteStatus
import org.zest.insan_360_website.model.Student
import org.zest.insan_360_website.model.StudentStatus


data class InviteState(
    val email: String = "",
    val isSending: Boolean = false,
) {
    companion object {
        private val EMAIL_REGEX = Regex("^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+\\.[a-zA-Z]+$")
    }

    fun validate(): String? {

        val sanitizedEmail = email.trim()
        if (sanitizedEmail.isBlank()) return userDashWordLibrary.enter_member_email.localized
        if (!sanitizedEmail.matches(EMAIL_REGEX)) return userDashWordLibrary.ensure_valid_email.localized

        val currentUserEmail = AuthState.email
        if (currentUserEmail != null && sanitizedEmail.equals(currentUserEmail, ignoreCase = true)) {
            return userDashWordLibrary.cannot_invite_self.localized
        }

        return null
    }
}

@OptIn(DelicateApi::class)
@Composable
fun AdminLayout() {
    PageContentBaseCol {
        UnifiedStudentList()
    }
}

@OptIn(DelicateApi::class)
@Composable
private fun UnifiedStudentList() {
    val modal = LocalModal.current
    val breakpoint = rememberBreakpoint()

    TableFlushedListContainer(
        1,
        header = {
            if (breakpoint >= Breakpoint.MD) {
                Row(
                    Modifier
                        .fillMaxWidth()
                        .gap(0.5.cssRem),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    SpanText(
                        LanguageSettings.UserDashboardPage.student_and_invite_list.localized,
                        Modifier.fontWeight(FontWeight.Bold).fontSize(1.5.cssRem).whiteSpace(WhiteSpace.NoWrap)
                    )
                    Row(
                        Modifier
                            .fillMaxWidth()
                            .justifyContent(JustifyContent.FlexEnd)
                            .gap(0.5.cssRem),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        StudentFilterInputs()
                    }
                }
            } else {
                Column(
                    Modifier
                        .fillMaxWidth()
                        .gap(0.5.cssRem)
                ) {
                    SpanText(
                        LanguageSettings.UserDashboardPage.student_and_invite_list.localized,
                        Modifier.fontWeight(FontWeight.Bold).fontSize(1.5.cssRem).whiteSpace(WhiteSpace.NoWrap)
                    )
                    Row(
                        Modifier
                            .fillMaxWidth()
                            .justifyContent(JustifyContent.FlexStart)
                            .gap(0.5.cssRem),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        StudentFilterInputs()
                    }
                }
            }
        },
        listHeaders = {
            ListHeader(
                "ID",
                modifier = Modifier
                    .position(Position.Sticky)
                    .left(0.5.cssRem)
                    .zIndex(10)
                    .backgroundColor(userPageBGColor)
                    .styleModifier { property("box-shadow", "-0.5rem 0 0 0 $userPageBGColor") }
            )
            ListHeader(userDashWordLibrary.name.localized)
            ListHeader(userDashWordLibrary.email.localized)
            ListHeader(userDashWordLibrary.phone_number.localized)
            ListHeader("Status")
            ListHeader("", true)
        },
        listHeadersModifier = Modifier
            .gap(0.25.cssRem)
            .grid {
                columns {
                    size(1.fr)
                    size(2.fr)
                    size(2.fr)
                    size(1.fr)
                    size(1.fr)
                    size(24.px)
                }
            }
    ) {
        val filteredMergedList = getFilteredMergedList()

        if (filteredMergedList.isEmpty()) {
            Box(Modifier.fillMaxWidth().minHeight(150.px).padding(1.cssRem), contentAlignment = Alignment.Center) {
                SpanText(
                    userDashWordLibrary.no_members_or_invites.localized,
                    Modifier.color(userPageSecondaryTextColor).fontWeight(FontWeight.Medium)
                )
            }
        } else {
            var index = 0
            filteredMergedList.forEach { (student, invite, _) ->
                if (student != null) {
                    FlushedListRowWrapper(
                        index = index,
                        modifier = Modifier
                            .cursor(Cursor.Pointer)
                            .onClick {
                                modal.show(Modifier.fillMaxWidth()) {
                                    StudentInfoModal(student)
                                }
                            }
                    ) {
                        Row(
                            Modifier
                                .fillMaxWidth()
                                .minWidth(1000.px)
                                .gap(0.25.cssRem)
                                .grid {
                                    columns {
                                        size(1.fr)
                                        size(2.fr)
                                        size(2.fr)
                                        size(1.fr)
                                        size(1.fr)
                                        size(24.px)
                                    }
                                },
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            val bgCol = if (index % 2 == 0) userPageColor else userPageBGColor
                            Box(
                                Modifier
                                    .fillMaxWidth()
                                    .position(Position.Sticky)
                                    .left(0.5.cssRem)
                                    .zIndex(2)
                                    .backgroundColor(bgCol)
                                    .styleModifier { property("box-shadow", "-0.5rem 0 0 0 $bgCol") }
                            ) {
                                CopyableIdText(student.id)
                            }
                            ListEntry(student.name)
                            ListEntry(student.email)
                            ListEntry(student.phone)
                            Box(Modifier.fillMaxWidth()) {
                                StudentStatusBadge(student.status)
                            }
                            Box(Modifier.fillMaxWidth(), contentAlignment = Alignment.Center) {
                                FaChevronRight(
                                    Modifier
                                        .color(userPageSecondaryTextColor)
                                        .fontSize(0.8.cssRem)
                                )
                            }
                        }
                    }
                } else if (invite != null) {
                    FlushedListRowWrapper(
                        index = index,
                        modifier = Modifier.cursor(Cursor.Default)
                    ) {
                        Row(
                            Modifier
                                .fillMaxWidth()
                                .minWidth(800.px)
                                .gap(0.25.cssRem)
                                .grid {
                                    columns {
                                        size(1.fr)
                                        size(2.fr)
                                        size(2.fr)
                                        size(1.fr)
                                        size(1.fr)
                                        size(24.px)
                                    }
                                },
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            val bgCol = if (index % 2 == 0) userPageColor else userPageBGColor
                            Box(
                                Modifier
                                    .fillMaxWidth()
                                    .position(Position.Sticky)
                                    .left(0.5.cssRem)
                                    .zIndex(2)
                                    .backgroundColor(bgCol)
                                    .styleModifier { property("box-shadow", "-0.5rem 0 0 0 $bgCol") }
                            ) {
                                SpanText(
                                    "-",
                                    Modifier
                                        .fontSize(0.85.cssRem)
                                        .color(userPageSecondaryTextColor)
                                )
                            }
                            ListEntry(invite.name ?: "-")
                            ListEntry(invite.email)
                            ListEntry("-")
                            Box(Modifier.fillMaxWidth()) {
                                InviteStatusBadge(invite.status)
                            }
                            Box(Modifier.width(24.px))
                        }
                    }
                }
                index++
            }
        }
    }
}


@Composable
private fun StudentInfoModal(student: Student) {
    val scope = rememberCoroutineScope()
    val toast = LocalToast.current
    val modal = LocalModal.current

    Column(
        Modifier
            .fillMaxWidth()
            .padding(1.cssRem)
            .gap(1.5.cssRem)
            .userSelect(UserSelect.None)
    ) {
        Row(
            Modifier.fillMaxWidth().justifyContent(JustifyContent.SpaceBetween),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Row(
                Modifier.gap(0.75.cssRem).flexWrap(FlexWrap.WrapReverse),
                verticalAlignment = Alignment.CenterVertically
            ) {
                SpanText(
                    student.id,
                    Modifier
                        .fontWeight(FontWeight.Bold)
                        .color(userPageSecondaryTextColor)
                        .userSelect(UserSelect.Text)
                )
                StudentStatusBadge(student.status)
            }
        }
        Column(Modifier.fillMaxWidth().minWidth(0.px).gap(0.25.cssRem)) {
            SpanText(
                student.name,
                Modifier
                    .fontSize(1.8.cssRem)
                    .fontWeight(FontWeight.Bold)
                    .lineHeight(1.2)
            )
            Row(
                Modifier.fillMaxWidth().minWidth(0.px).gap(0.5.cssRem).color(userPageSecondaryTextColor)
                    .cursor(Cursor.Pointer)
                    .onClick {
                        window.navigator.clipboard.writeText(student.email)
                        toast.show(LanguageSettings.UserDashboardPage.email_copied.localized, ToastType.SUCCESS)
                    },
                verticalAlignment = Alignment.CenterVertically
            ) {
                FaEnvelope(Modifier.flexShrink(0))
                SpanText(
                    student.email, 
                    Modifier
                        .fontWeight(FontWeight.Medium)
                        .whiteSpace(WhiteSpace.NoWrap)
                        .overflow(Overflow.Hidden)
                        .textOverflow(TextOverflow.Ellipsis)
                        .title(student.email)
                )
            }
        }
        Box(
            Modifier
                .fillMaxWidth()
                .height(1.px)
                .backgroundColor(userPageBorderStrongColor)
        )

        Column(Modifier.gap(0.75.cssRem)) {
            Row(Modifier.gap(0.75.cssRem), verticalAlignment = Alignment.CenterVertically) {
                FaIdCard(Modifier.color(userPageSecondaryTextColor))
                SpanText(student.nric)
            }
            Row(Modifier.gap(0.75.cssRem), verticalAlignment = Alignment.CenterVertically) {
                FaPhone(Modifier.color(userPageSecondaryTextColor))
                SpanText(student.phone)
            }
            Row(Modifier.gap(0.75.cssRem), verticalAlignment = Alignment.CenterVertically) {
                FaLocationDot(Modifier.color(userPageSecondaryTextColor))
                SpanText(student.address)
            }
            Row(Modifier.gap(0.75.cssRem), verticalAlignment = Alignment.CenterVertically) {
                FaBriefcase(Modifier.color(userPageSecondaryTextColor))
                SpanText(student.workType)
            }
        }

        Row(
            Modifier.fillMaxWidth().justifyContent(JustifyContent.FlexEnd)
        ) {
            Box(
                Modifier
                    .fontSize(1.1.cssRem)
                    .onClick {
                        assignCredit(student.id, scope, toast) {
                            needUpdate = true
                            modal.hide()
                        }
                    }
                    .then(contentButtonStyle.toModifier())
            ) {
                SpanText(
                    userDashWordLibrary.assign_credit.localized,
                    modifier = Modifier.then(contentButtonTextStyle.toModifier())
                )
            }
        }
    }
}

@Composable
fun StudentStatusBadge(status: StudentStatus) {
    val statusColor = when (status) {
        StudentStatus.VERIFIED -> Color.rgb(0x16a34a)
        StudentStatus.ASSIGNED -> Color.rgb(0x2563eb)
        StudentStatus.IN_PROGRESS -> Color.rgb(0xca8a04)
        StudentStatus.PENDING -> Color.rgb(0xd97706)
        StudentStatus.REJECTED -> Color.rgb(0xdc2626)
        StudentStatus.UNASSIGNED -> Color.rgb(0x6b7280)
    }

    StatusBadge(
        text =  userDashWordLibrary.studentStatus[status]?.get(UserPreferences.language) ?: when(status) {
            StudentStatus.VERIFIED -> "VERIFIED"
            StudentStatus.ASSIGNED -> "ACTIVE"
            StudentStatus.IN_PROGRESS -> "IN PROGRESS"
            StudentStatus.PENDING -> "PENDING"
            StudentStatus.REJECTED -> "REJECTED"
            StudentStatus.UNASSIGNED -> "UNASSIGNED"
        },
        color = statusColor
    )
}

@Composable
fun InviteStatusBadge(status: InviteStatus) {
    val statusColor = when (status) {
        InviteStatus.ACCEPTED -> Color.rgb(0x16a34a)
        InviteStatus.INVITED -> Color.rgb(0xd97706)
        InviteStatus.EXPIRED -> Color.rgb(0xdc2626)
    }

    StatusBadge(
        text = userDashWordLibrary.inviteStatus[status]?.get(UserPreferences.language) ?: when (status) {
            InviteStatus.ACCEPTED -> "ACCEPTED"
            InviteStatus.INVITED -> "INVITED"
            InviteStatus.EXPIRED -> "EXPIRED"
        },
        color = statusColor
    )
}

@OptIn(DelicateApi::class)
@Composable
private fun StudentFilterInputs() {
    val scope = rememberCoroutineScope()
    val toast = LocalToast.current
    val breakpoint = rememberBreakpoint()
    val isMobile = breakpoint < Breakpoint.MD

    val actionButtonModifier = Modifier
        .cursor(Cursor.Pointer)
        .then(contentButtonStyle.toModifier())
        .padding(topBottom = 0.325.cssRem, leftRight = 1.cssRem)
        .borderRadius(0.25.cssRem)
        .display(DisplayStyle.Flex)
        .alignItems(AlignItems.Center)
        .justifyContent(JustifyContent.Center)

    val actionButtonTextModifier = Modifier
        .then(contentButtonTextStyle.toModifier())
        .fontFamily("FunnelDisplay")
        .fontWeight(FontWeight.SemiBold)
        .fontSize(0.95.cssRem)

    val cancelButtonModifier = Modifier
        .cursor(Cursor.Pointer)
        .then(contentRedButtonStyle.toModifier())
        .padding(topBottom = 0.325.cssRem, leftRight = 1.cssRem)
        .borderRadius(0.25.cssRem)
        .display(DisplayStyle.Flex)
        .alignItems(AlignItems.Center)
        .justifyContent(JustifyContent.Center)

    if (isInviting) {
        if (isMobile) {
            Column(Modifier.fillMaxWidth().gap(0.5.cssRem)) {
                Input(
                    InputType.Email,
                    attrs = Modifier
                        .fillMaxWidth()
                        .fontFamily("FunnelDisplay")
                        .fontWeight(FontWeight.SemiBold)
                        .padding(0.325.cssRem)
                        .borderRadius(0.25.cssRem)
                        .border {
                            width(1.px)
                            style(LineStyle.Solid)
                            color(userPageBorderStrongColor)
                        }
                        .backgroundColor(userPageBGColor)
                        .color(userPagePrimaryTextColor)
                        .outline(0.px)
                        .toAttrs {
                            value(inviteEmail)
                            onInput { inviteEmail = it.value }
                            attr("placeholder", userDashWordLibrary.member_email_placeholder.localized)
                        }
                )
                Row(Modifier.fillMaxWidth().gap(0.5.cssRem)) {
                    Box(
                        Modifier
                            .flex(1)
                            .onClick {
                                isInviting = false
                                isConfirmingInvite = false
                                inviteEmail = ""
                            }
                            .then(cancelButtonModifier)
                    ) {
                        SpanText(
                            userDashWordLibrary.cancel.localized,
                            modifier = actionButtonTextModifier
                        )
                    }
                    Box(
                        Modifier
                            .flex(1)
                            .onClick {
                                val tempState =
                                    inviteState.copy(email = inviteEmail)
                                val error = tempState.validate()
                                if (error != null) {
                                    toast.show(error)
                                    isConfirmingInvite = false
                                } else {
                                    if (isConfirmingInvite) {
                                        inviteState = tempState
                                        sendInvite(scope, toast) {
                                            isInviting = false
                                            isConfirmingInvite = false
                                            inviteEmail = ""
                                        }
                                    } else {
                                        isConfirmingInvite = true
                                    }
                                }
                            }
                            .then(actionButtonModifier)
                    ) {
                        val text =
                            if (isConfirmingInvite) userDashWordLibrary.confirm.localized
                            else userDashWordLibrary.send.localized
                        SpanText(text, modifier = actionButtonTextModifier)
                    }
                }
            }
        } else {
            Row(
                Modifier.gap(0.5.cssRem).fillMaxWidth().justifyContent(JustifyContent.FlexEnd),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Input(
                    InputType.Email,
                    attrs = Modifier
                        .maxWidth(480.px)
                        .flex(1)
                        .fontFamily("FunnelDisplay")
                        .fontWeight(FontWeight.SemiBold)
                        .padding(0.325.cssRem)
                        .borderRadius(0.25.cssRem)
                        .border {
                            width(1.px)
                            style(LineStyle.Solid)
                            color(userPageBorderStrongColor)
                        }
                        .backgroundColor(userPageBGColor)
                        .color(userPagePrimaryTextColor)
                        .outline(0.px)
                        .toAttrs {
                            value(inviteEmail)
                            onInput { inviteEmail = it.value }
                            attr("placeholder", userDashWordLibrary.member_email_placeholder.localized)
                        }
                )
                Box(
                    Modifier
                        .onClick {
                            isInviting = false
                            isConfirmingInvite = false
                            inviteEmail = ""
                        }
                        .then(cancelButtonModifier)
                ) {
                    SpanText(
                        userDashWordLibrary.cancel.localized,
                        modifier = actionButtonTextModifier
                    )
                }
                Box(
                    Modifier
                        .onClick {
                            val tempState =
                                inviteState.copy(email = inviteEmail)
                            val error = tempState.validate()
                            if (error != null) {
                                toast.show(error)
                                isConfirmingInvite = false
                            } else {
                                if (isConfirmingInvite) {
                                    inviteState = tempState
                                    sendInvite(scope, toast) {
                                        isInviting = false
                                        isConfirmingInvite = false
                                        inviteEmail = ""
                                    }
                                } else {
                                    isConfirmingInvite = true
                                }
                            }
                        }
                        .then(actionButtonModifier)
                ) {
                    val text =
                        if (isConfirmingInvite) userDashWordLibrary.confirm.localized
                        else userDashWordLibrary.send.localized
                    SpanText(text, modifier = actionButtonTextModifier)
                }
            }
        }
    } else {
        Row(
            Modifier.gap(0.5.cssRem).then(if (isMobile) Modifier.fillMaxWidth() else Modifier),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Input(
                InputType.Text,
                attrs = Modifier
                    .flex(1)
                    .fontFamily("FunnelDisplay")
                    .fontWeight(FontWeight.SemiBold)
                    .padding(0.325.cssRem)
                    .borderRadius(0.25.cssRem)
                    .border {
                        width(1.px)
                        style(LineStyle.Solid)
                        color(userPageBorderStrongColor)
                    }
                    .backgroundColor(userPageBGColor)
                    .color(userPagePrimaryTextColor)
                    .outline(0.px)
                    .toAttrs {
                        value(searchQuery)
                        onInput { searchQuery = it.value }
                        attr(
                            "placeholder",
                            userDashWordLibrary.search.localized
                        )
                    }
            )
            Box(
                Modifier
                    .onClick { isInviting = true }
                    .then(actionButtonModifier)
            ) {
                SpanText(
                    userDashWordLibrary.invite.localized,
                    modifier = actionButtonTextModifier
                )
            }
        }
    }
}